var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgHash(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.467 1.303A4.566 4.566 0 005.811 1a4.834 4.834 0 101.656.303zM5.811 8.562a2.757 2.757 0 01-2.75-2.75 2.758 2.758 0 012.75-2.75 2.75 2.75 0 010 5.5z",
    fill: "#ED8282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.522 5.813A1.706 1.706 0 015.81 7.525a1.67 1.67 0 01-.982-.323 1.697 1.697 0 01-.225-2.6c.32-.32.755-.5 1.207-.501.13-.001.26.015.386.048a1.705 1.705 0 011.326 1.664z",
    fill: "#ED8282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81 4.1c.13 0 .26.016.386.049L4.827 7.21a1.697 1.697 0 01-.73-1.395A1.718 1.718 0 015.81 4.101z",
    fill: "#FA9898"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.467 1.303l-.84 1.884A2.747 2.747 0 004.4 8.17l-.845 1.897A4.816 4.816 0 015.81 1c.567-.003 1.128.1 1.657.303z",
    fill: "#FA9898"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.785 13.389c-.096 0-.185-.015-.282-.015h-2.632a3.505 3.505 0 00-3.5 3.5v2.632a3.489 3.489 0 002.235 3.245c.402.162.832.244 1.265.242h2.633a3.498 3.498 0 003.493-3.493v-2.626a3.498 3.498 0 00-3.212-3.485zm1.15 6.122a1.43 1.43 0 01-1.431 1.431H16.87c-.145 0-.289-.021-.427-.063a1.45 1.45 0 01-1.01-1.368v-2.637a1.44 1.44 0 011.437-1.438h2.633a1.435 1.435 0 011.43 1.438v2.637z",
    fill: "#7EE6A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.89 17.369v1.637a.881.881 0 01-.886.886h-1.637a.849.849 0 01-.434-.116.873.873 0 01-.453-.77v-1.637a.888.888 0 01.887-.887h1.637a.883.883 0 01.886.887z",
    fill: "#7EE6A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.79 8.09a3.797 3.797 0 01-3.706 4.583h-6.01c-1.32 0-2.512.988-2.568 2.308a2.417 2.417 0 002.417 2.518h2.386a.688.688 0 110 1.376H9.115c-1.995 0-3.795-1.45-3.97-3.443a3.79 3.79 0 013.771-4.133h6.08c1.163 0 2.23-.786 2.454-1.934a2.416 2.416 0 00-2.366-2.9h-2.4a.688.688 0 010-1.374h2.218c1.827 0 3.52 1.21 3.888 2.998z",
    fill: "#A3BECC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.367 16.482h1.032l-1.466 3.294a.873.873 0 01-.453-.77v-1.637a.888.888 0 01.887-.887z",
    fill: "#98FAB9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.785 13.389l-.913 2.047H16.87a1.44 1.44 0 00-1.437 1.438v2.632a1.45 1.45 0 001.01 1.368l-.838 1.878a3.488 3.488 0 01-2.235-3.246v-2.632a3.505 3.505 0 013.5-3.5h2.633c.096 0 .183.006.281.014z",
    fill: "#98FAB9"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h22v22H0z"
  })))));
}
export default SvgHash;